import React from 'react'

import { encodeQueryString } from '../../../../../app/queryString'
import { Button } from '../../../../components/button'
import { Icon } from '../../../../components/icon'
import { Heading } from '../../../../components/typography'

export function EliteAdOverlay({ onOverlayClick }: { onOverlayClick: () => void }) {
  return (
    <div
      className="absolute z-10 flex h-full w-full items-center justify-center bg-primary/80"
      onClick={onOverlayClick}
    >
      <div className="flex w-3/4 flex-col items-center space-y-4">
        <div className="flex w-full items-center space-x-2">
          <Icon name="lock" width="24" className="text-violet-400" />
          <Heading level={4} className="m-0">
            Subscribe to FINVIZ*Elite to unlock data
          </Heading>
        </div>
        <div className="text-left text-sm">
          Beat the market and make more informed decisions with our premium features. Real-time quotes, intraday charts,
          indicators, alerts, historical statements, and much more.
        </div>
        <div className="flex w-full justify-start">
          <Button
            as="a"
            theme="violet"
            href={`/elite.ashx?${encodeQueryString({
              utm_source: 'finviz',
              utm_medium: 'etf-holdings',
              utm_campaign: 'all-holdings-data',
            })}`}
            target="_blank"
          >
            Unlock All Holdings Data
          </Button>
        </div>
      </div>
    </div>
  )
}
